import React, {useEffect, useState} from "react";
import ChatLogs from "../admin/default/components/LogsDatatable";
import axios from "axios";
import {APIURL} from "../../variables/constants";
import {populateAllChats} from "../../actions";
import {useSelector} from "react-redux";

const ChatListPage = () => {
    let AllChats = useSelector(state => state.AllChats)

    return (
        <div className="grid grid-cols-1 gap-5 mt-5">
            <ChatLogs
                nbrows={50}
                tableData={AllChats}
            />

        </div>
    );
};

export default ChatListPage;
